import {
	Component,
	OnInit,
	ViewChild,
	ElementRef,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { InstructionsMethodComponent } from "@app/instructions-method/instructions-method.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { SafeHtmlPipe } from "@app/utils/safe-html.pipe"
import { CancelBtnComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-open-instructions",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		SafeHtmlPipe,
		CancelBtnComponent,
		ModalWrapComponent,
		InstructionsMethodComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div class="row instructions">
			<div class="col-12">
				<p>
					{{ "wellcome" | langVal }}.
					<br />
					<br />
					<span
						[innerHTML]="'do_you_want_instruction' | langVal | safeHtml"
					></span>
				</p>
			</div>
		</div>

		<div class="modal-btns">
			<app-cancel-btn (click)="onClose.emit()" />
			<button
				class="btn btn-primary"
				(click)="isMethodOpen = true"
			>
				{{ "i_want_instruction" | langVal }}
			</button>
			<button
				class="btn btn-default"
				(click)="update_wants_instruction(true)"
			>
				{{ "decline_instructions" | langVal }}
			</button>
		</div>
		@if (isMethodOpen) {
			<app-modal-wrap
				(onClose)="isMethodOpen = false; onClose.emit()"
				title="please_select_how_to_contact"
				modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
			>
				<app-instructions-method
					(onClose)="isMethodOpen = false; handleMethodClose($event)"
				/>
			</app-modal-wrap>
		}
	`,
})
export class OpenInstructionsComponent extends Modalable {
	isMethodOpen: boolean = false
	handleMethodClose(res: any) {
		if (!res) {
			return this.onClose.emit()
		}
		this.update_wants_instruction(false, res.isWhatsapp)
	}

	async update_wants_instruction(
		is_decline: boolean = false,
		isWhatsapp: boolean = false
	) {
		this.onClose.emit(true)
		await this.apiService.post("update_wants_instruction", {
			is_decline,
			isWhatsapp,
		})
		if (!is_decline) {
			this.modalService.openToast("message_sent_to_instructor")
		}
	}
}
